@if (hasTrial === false) {
    <div>
        <div aria-live="polite" class="tw-font-xs tw-font-bold tw-text-black tw-pb-5" translate>v3-advanced-searchbar-label</div>
        <div
            class="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-6"
            [ngClass]="[hasTwoColumnGridClass ? '2xl:tw-grid-cols-2' : '2xl:tw-grid-cols-3']"
            appList
            [id]="listId"
        >
            @for (category of skillCategories; track category.id) {
                <a
                    [routerLink]="['/explore', 'skill-category', category.id]"
                    app-button-search
                    [text]="category.name"
                    [linkDataTest]="'exploreCategoryLink' + category.id"
                    appListItem
                >
                </a>
            }
        </div>
    </div>
}
